import { FC, useMemo } from 'react'
import { createFloatingPaneByTypeSelector } from 'selectors/floatingPanesSelectors'
import { useStoreSelector } from 'helpers/reactReduxHelpers'

import {
  CRYPTO_REWARDS_BUY_MODE_STEP_CURRENCY_LIST,
  CRYPTO_REWARDS_BUY_MODE_STEP_INVESTMENTS_AMOUNT,
  CRYPTO_REWARDS_BUY_MODE_STEP_SEND_ORDER,
  CRYPTO_REWARDS_BUY_MODE_STEP_SUCCESS,
} from 'components/features/rewards/rewardsPane/constants/paneSteps'
import { FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE, FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE } from 'components/features/rewards/rewardsPane/constants/paneState'
import { CryptoRewardsPane } from 'components/features/rewards/rewardsPane/types/paneState'
import { CryptoRewardsBuyAmountStep } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsBuyPane/CryptoRewardsBuyAmountStep/CryptoRewardsBuyAmountStep'
// eslint-disable-next-line import-newlines/enforce
import { CryptoRewardsBuySendingOrderStep } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsBuyPane/CryptoRewardsBuySendingOrderStep/CryptoRewardsBuySendingOrderStep'
import { CryptoRewardsBuySuccessStep } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsBuyPane/CryptoRewardsBuySuccessStep/CryptoRewardsBuySuccessStep'
// eslint-disable-next-line import-newlines/enforce
import { CryptoRewardsBuyCurrencyListStep } from 'components/features/rewards/rewardsPane/containers/CryptoRewardsBuyPane/CryptoRewardsBuyCurrencyListStep/CryptoRewardsBuyCurrencyListStep'

type CryptoRewardsBuyPanePaneProps = {
  onClose: () => void
}
export const CryptoRewardsBuyPane: FC<CryptoRewardsBuyPanePaneProps> = ({ onClose }) => {
  const paneSelector = useMemo(createFloatingPaneByTypeSelector, [])
  const pane = useStoreSelector((state) => paneSelector(state, FLOATING_PANE_CRYPTO_REWARDS_PANE_TYPE)) as Extract<CryptoRewardsPane, { mode: typeof FLOATING_PANE_CRYPTO_REWARDS_BUY_MODE }> | null

  if (!pane) {
    return null
  }

  switch (pane.step) {
    case CRYPTO_REWARDS_BUY_MODE_STEP_INVESTMENTS_AMOUNT:
      return (
        <CryptoRewardsBuyAmountStep onClose={ onClose } />
      )

    case CRYPTO_REWARDS_BUY_MODE_STEP_CURRENCY_LIST:
      return (
        <CryptoRewardsBuyCurrencyListStep onClose={ onClose } />
      )

    case CRYPTO_REWARDS_BUY_MODE_STEP_SEND_ORDER:
      return (
        <CryptoRewardsBuySendingOrderStep onClose={ onClose } />
      )

    case CRYPTO_REWARDS_BUY_MODE_STEP_SUCCESS:
      return (
        <CryptoRewardsBuySuccessStep onClose={ onClose } />
      )
  }

  return null
}
